/*
@phone        : принимаемое значение телефона на данный момент
@countryCode  : код страны в тектовом значении (для России RU)
@phoneCode    : код страны, для которой применяется маска той самой страны (например, для России это будет +7)
@phoneLength  : число, обозначает длину телефона в стране, в России это 10
*/


function formatPhoneNumber(phone, phoneCode = '+7', countryCode = 'RU', phoneLength = 10) {
  // Убираем все плюсы, кроме первого
  if (phone.startsWith('+')) {
    phone = '+' + phone.slice(1).replace(/\+/g, '');
  }

  // Условие для России (RU): если номер начинается с 8 или 7
  if (phone.length > 0 && (phone.charAt(0) === '8' || phone.charAt(0) === '7') && countryCode === 'RU') {
    phone = "+7" + phone.substring(1);
  }

  // Условие для Узбекистана (UZ): если номер начинается с 9
  if (phone.length > 0 && phone.charAt(0) === '9' && countryCode === 'UZ') {
    phone = '+998' + phone.substring(1);
  }

  // Добавляем код страны, если длина номера соответствует длине без кода страны
  if (phone.length === phoneLength && !phone.startsWith(phoneCode)) {
    phone = phoneCode + phone;
  }

  return phone;
}

export default formatPhoneNumber